'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function identity(x) {
    return x;
}
exports.identity = identity;
